import React, { Component } from 'react';
import { BlockPicker as ColorPicker } from 'react-color';
import { TextField, RaisedButton, DropDownMenu, MenuItem } from 'material-ui';
import { FileUpload } from '../../components';
import './css/PushForm.css';

class PushForm extends Component {
    constructor(){
        super();
        this.state = {
            actionValue: 3,
            notification: {
                
            }
        }

        this.notification = {};

        this.imageFormClasses = ['imageForm'];
        this.urlFormClasses = ['urlForm'];
    }

    handleTextChange = (key, val) => {
        this.notification[key] = val;
        this.setState({
            notification: {
                ...this.state.notification,
                [key]: val,
            }
        })
        this.props.sendUp(this.notification)
    }


    handlePushAction = (e, index, val) => {
        if(val == 1)
            this.urlFormClasses.push('expandField');
        if(val == 2)
            this.imageFormClasses.push('expandField');
        
        let action = '';

        switch(val) {
            case 1: 
            case 2: action = 'FLUTTER_NOTIFICATION_CLICK';
        }

        this.notification.action = action;
        

        this.setState({actionValue: val})

        this.props.sendUp(this.notification)
    }

    renderPushAction = (val) => {
        if(val == 1)
            return(
                <TextField
                    hintText={'Paste a Link.'}
                    floatingLabelText={'URL'}
                    onChange={(e, val) => this.handleTextChange('url', val)}
                />
            )

        if(val == 2)
            return(
                <FileUpload 
                    style={{ marginTop: 16 }}
                    onFileUploaded={url => this.handleTextChange( 'url', url )}
                />
            )
    }

    render(){
        const {
            actionValue,
        } = this.state;

        return(
            <section style={styles.container}>
            
                <TextField 
                    hintText={'Make it spicy!'} 
                    floatingLabelText={'Title'}
                    onChange={(e, val) => this.handleTextChange('title', val)}
                />
                <TextField 
                    hintText={'What would you like to say to your subscribers?'} 
                    multiLine={true}
                    floatingLabelText={'Message Body'}
                    onChange={(e, val) => this.handleTextChange('body', val)}
                    style={{width: '50%'}}
                />
                {/* <TextField 
                    hintText={'Make some noise!'} 
                    floatingLabelText={'Sound'}
                    onChange={(e, val) => this.handleTextChange('sound', val)}
                /> */}
                <TextField 
                    hintText={'#FFFFFF'} 
                    floatingLabelText={'Color'}
                    onChange={(e, val) => this.handleTextChange('color', val)}
                    value={this.state.notification.color}
                />
                <ColorPicker
                    onChangeComplete={ color => this.handleTextChange('color', color.hex)}
                    color={this.state.notification.color}
                />
                <DropDownMenu 
                    floatingLabelText="Open action"
                    maxHeight={300}
                    anchorOrigin={{ vertical: 'center', horizontal: 'left',}}
                    value={this.state.actionValue} 
                    onChange={this.handlePushAction}
                    style={{width: '25%', padding: 0, marginTop: '15px', minWidth: '150px'}}
                    labelStyle={{padding: 0}}
                    underlineStyle={{marginLeft: 0}}
                >
                    {/* <MenuItem value={0} key={0} primaryText={'Select Open Action'} />
                    <MenuItem value={1} key={1} primaryText={'Open URL'} />
                    <MenuItem value={2} key={2} primaryText={'Open Image'} /> */}
                    <MenuItem value={3} key={3} primaryText={'Open App Home'} />
                </DropDownMenu>
                
                {this.renderPushAction(actionValue)}
    
            </section>
        );
    }
}

export default PushForm;

const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
    },
    stepper: {
      display: 'flex',
      flex: 1,
    }
  }


// WEBPACK FOOTER //
// ./src/components/createEditPush/PushForm.js